import { createSlice } from '@reduxjs/toolkit';
import { TasksGridStateType } from 'src/types/tasksGrid';

const initialState: TasksGridStateType = {
    data: null,
    loading: false,
    error: false,
};
export const tasksSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        getTasksGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getTasksGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getTasksGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        confirmTaskFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        confirmTaskFetchSuccess: (state, action) => {
            state.data = [...(state.data || []).filter((item) => item.ID !== action.payload.ID)];
            state.loading = false;
        },
        confirmTaskFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getTasksGridFetch,
    getTasksGridFetchSuccess,
    getTasksGridFetchFailure,
    confirmTaskFetch,
    confirmTaskFetchSuccess,
    confirmTaskFetchFailure,
} = tasksSlice.actions;

export default tasksSlice.reducer;
